import script from "./LeftPart.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftPart.vue?vue&type=script&setup=true&lang=js"

import "./LeftPart.vue?vue&type=style&index=0&id=493c22cf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493c22cf"]])

export default __exports__